<template>
    <div class="dictionary">
        <div class="tree-box">
            <div class="tree-btn">
                <a-button type="primary" @click="addDictionary('新增字典','add')" v-if="powerArr.indexOf('back:dict:save')>-1" :disabled="isChild">新增</a-button>
                <a-button type="primary" @click="addDictionary('修改字典','edit')" v-if="powerArr.indexOf('back:dict:update')>-1" :disabled="selectInfo==''">修改</a-button>
                <a-button type="primary" @click="coopyInfo" v-if="powerArr.indexOf('back:dict:update')>-1" :disabled="selectInfo==''||selectF===''">复制</a-button>
                <a-button v-if="powerArr.indexOf('back:dict:delete')>-1" @click="delDictionary" :disabled="selectInfo==''">删除</a-button>
                <a-button v-if="powerArr.indexOf('back:dict:refresh')>-1" @click="refreshDictionary">刷新缓存</a-button>
            </div>
            <div class="tree">
                <a-tree
                    class="draggable-tree"
                    :default-expanded-keys="expandedKeys"
                    :replace-fields="replaceFields"
                    draggable
                    :tree-data="gData"
                    @drop="onDrop"
                    @select='treeSelect'
                    :selectedKeys='selectedKeys'
                />
            </div>
        </div>
        <div class="main-box" v-if="activeType!=''">
            <h3>{{activeTitle}}</h3>
            <div class="input-box">
                <p>查询编码：</p>
                <a-input class="input" v-model="data.parentId" disabled/>
            </div>
            <div class="input-box">
                <p>字典编码：</p>
                <a-input class="input" v-model="data.dataCode" />
            </div>
            <div class="input-box">
                <p>字典名称：</p>
                <a-input class="input" v-model="data.dataName" @change="nameChange"/>
            </div>
            <div class="input-box">
                <p>字典简称：</p>
                <a-input class="input" v-model="data.simpleName" />
            </div>
            <div class="input-box">
                <p>拼音：</p>
                <a-input class="input" v-model="data.spell" />
            </div>
            <div class="input-box">
                <p>排序：</p>
                <a-input class="input" v-model="data.sortNo" />
            </div>
            <div class="input-box">
                <p>是否常用：</p>
                <a-switch v-model="data.usual" />
            </div>
            <div class="input-box">
                <p>是否启用：</p>
                <a-switch v-model="data.status" />
            </div>
            <div class="input-box">
                <p>描述：</p>
                <a-textarea :rows="4"  class="input" v-model="data.dataDesc"/>
            </div>
            <div class="active-btn">
                <a-button icon="sync" @click="reset">重置</a-button>
                <a-button type="primary" @click="sub">保存</a-button>
            </div>
        </div>
    </div>
</template>

<script>
    import { list,add,edit,del,refresh } from '@/baseAPI/dictionary'
    export default {
        name: 'Dictionary',
        components: {
        },
        computed: {},
        data() {
            return {
                gData:[],
                replaceFields: {
                    title: 'dataName',
                    key:'id'
                },
                expandedKeys: [1],   
                selectArr:[],   
                selectInfo:'',
                activeType:'',   
                activeTitle:'',
                powerArr:[],
                data:{
                    parentId:'',
                    dataCode:'',
                    dataName:'',
                    simpleName:'',
                    spell:'',
                    sortNo:'',
                    dataDesc:'',
                    status:true,
                    usual:false,
                },
                isChild:false,
                selectF:'',
                selectedKeys:[],
            }
        },
        mounted () {
            this.powerArr=this.$store.state.user.permissions==null?[]:this.$store.state.user.permissions;
            this.getDictionary()
        },
        methods:{
            onDrop(info) {
                const dropKey = info.node.eventKey;
                const dragKey = info.dragNode.eventKey;
                const dropPos = info.node.pos.split('-');
                const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1]);
                const loop = (data, key, callback) => {
                    data.forEach((item, index, arr) => {
                    if (item.key === key) {
                        return callback(item, index, arr);
                    }
                    if (item.children) {
                        return loop(item.children, key, callback);
                    }
                    });
                };
                const data = [...this.gData];

                // Find dragObject
                let dragObj;
                loop(data, dragKey, (item, index, arr) => {
                    arr.splice(index, 1);
                    dragObj = item;
                });
                if (!info.dropToGap) {
                    // Drop on the content
                    loop(data, dropKey, item => {
                    item.children = item.children || [];
                    // where to insert 示例添加到尾部，可以是随意位置
                    item.children.push(dragObj);
                    });
                } else if (
                    (info.node.children || []).length > 0 && // Has children
                    info.node.expanded && // Is expanded
                    dropPosition === 1 // On the bottom gap
                ) {
                    loop(data, dropKey, item => {
                    item.children = item.children || [];
                    // where to insert 示例添加到尾部，可以是随意位置
                    item.children.unshift(dragObj);
                    });
                } else {
                    let ar;
                    let i;
                    loop(data, dropKey, (item, index, arr) => {
                    ar = arr;
                    i = index;
                    });
                    if (dropPosition === -1) {
                    ar.splice(i, 0, dragObj);
                    } else {
                    ar.splice(i + 1, 0, dragObj);
                    }
                }
                this.gData = data;
            },  
            treeSelect(selectedKeys){
                this.selectedKeys=selectedKeys;
                this.selectArr=[];
                this.forTree(this.gData,selectedKeys[0])
                var obj='';
                if(this.selectArr.length>0){
                    obj=this.gData;
                    for(let i=this.selectArr.length-1;i>-1;i--)
                    {
                        if(obj.children==null){
                            obj=obj[this.selectArr[i]];
                            this.selectF=obj.id;
                        }else{
                            obj=obj.children[this.selectArr[i]]
                        }
                    }
                }
                if(this.selectArr.length<2){
                    this.selectF='';
                }
                this.selectInfo=this.deepCopy(obj)
                if(this.selectArr.length==2){
                    this.isChild=true;
                    this.addDictionary('修改字典','edit')
                }else{
                    this.isChild=false;
                }
                if(this.activeType=='add'){
                    if(this.selectInfo==''){
                        this.data.parentId='0';
                    }else{
                        this.data.parentId=this.selectInfo.id;
                    }
                }else if(this.activeType=='edit'){
                    if(this.selectInfo==''){
                        this.activeType=''
                    }else{
                        this.data=this.deepCopy(this.selectInfo);
                    }
                }
            },
            forTree(arr,str){
                for(let i=0;i<arr.length;i++){
                    if(arr[i].id==str){
                        this.selectArr.push(i)
                        return i;
                    }
                    if(arr[i].children!=null){
                        var num=this.forTree(arr[i].children,str);
                        if(num!==''){
                            this.selectArr.push(i)
                            return i;
                        }
                    }
                }
                return '';
            },
            getDictionary(){
                list().then(res=>{
                    this.gData=res.data;
                })
            },
            addDictionary(text,type){
                this.activeTitle=text;
                this.activeType=type;
                if(type=='add'){
                    this.data={
                        parentId:'',
                        dataCode:'',
                        dataName:'',
                        simpleName:'',
                        spell:'',
                        sortNo:'',
                        dataDesc:'',
                        status:true,
                        usual:false,
                    };
                    if(this.selectInfo==''){
                        this.data.parentId='0';
                    }else{
                        this.data.parentId=this.selectInfo.id;
                    }
                }else if(type=='edit'){
                    if(this.selectInfo==''){
                        this.activeType='';
                        this.$notification['info']({
                            message: '提示',
                            description:'请选择某一字典再进行修改',
                        });
                    }else{
                        this.data=this.deepCopy(this.selectInfo);
                    }
                }else if(type=='addCoopy'){
                    this.data=this.deepCopy(this.selectInfo);
                    this.data.id='';
                    this.activeType='add';
                }
            },
            refreshDictionary(){
                refresh().then(res=>{
                    if(res.data.success){
                        this.$notification['success']({
                            message: '成功',
                            description:'刷新字典成功',
                        });
                        this.activeType='';
                        this.getDictionary()
                    }else{
                        this.$notification['error']({
                            message: '错误',
                            description:res.data.errorMessage,
                        });
                    }

                })
            },
            delDictionary(){
                if(this.selectInfo==''){
                    this.$notification['info']({
                        message: '提示',
                        description:'请选择某一字典再进行删除',
                    });
                }else{
                    del(this.selectInfo.id).then(res=>{
                        if(res.data.success){
                            this.$notification['success']({
                                message: '成功',
                                description:'删除字典成功',
                            });
                        }else{
                            this.$notification['error']({
                                message: '失败',
                                description:res.data.errorMessage,
                            });
                        }
                    })
                }
            },
            sub(){
                if(this.activeType=='add'){
                    add(this.data).then(res=>{
                        if(res.data.success){
                            this.$notification['success']({
                                message: '成功',
                                description:'新增字典成功',
                            });
                        }else{
                            this.$notification['error']({
                                message: '失败',
                                description:res.data.errorMessage,
                            });
                        }
                    })
                }else if(this.activeType=='edit'){
                    edit(this.data).then(res=>{
                        if(res.data.success){
                            this.$notification['success']({
                                message: '成功',
                                description:'修改字典成功',
                            });
                        }else{
                            this.$notification['error']({
                                message: '失败',
                                description:res.data.errorMessage,
                            });
                        }
                    })
                }
            },
            reset(){
                if(this.activeType=='add'){
                    this.data={
                        parentId:'',
                        dataCode:'',
                        dataName:'',
                        sortNo:'',
                        dataDesc:'',
                        status:true,
                    };
                    if(this.selectInfo==''){
                        this.data.parentId='0';
                    }else{
                        this.data.parentId=this.selectInfo.id;
                    }
                }else if(this.activeType=='edit'){
                    this.data=this.deepCopy(this.selectInfo);
                }
            },
            nameChange(){
                if(this.activeType=='add'){
                    this.data.simpleName=this.data.dataName;
                }
            },
            coopyInfo(){
                console.log(this.selectInfo)
                this.selectedKeys=[this.selectF];
                this.selectF='';
                this.addDictionary('新增字典','addCoopy',)
            }
        }
    }
</script>

<style scoped>
    .dictionary{
        display: flex;
        height: 100%;
    }
    .tree-box{
        width: 40%;
        height: 100%;
        overflow: auto;
        border-right: 1px solid #ccc;
        display: flex;
        flex-direction: column;
    }
    .tree-box .ant-btn{
        margin-right: 1rem;
    }
    .tree-box .tree{
        flex: 1;
        overflow: auto;
        padding: 15px;
        padding-left: 0;
    }
    .main-box{
        width: 60%;
        height: 100%;
        overflow: auto;
        padding: 15px;
        padding-right: 0;
    }
    .main-box h3{
        text-align: center;
        letter-spacing: 2px;
        font-weight: bold;
        color: #40a9ff;
    }
    .input-box{
        width: 70%;
        margin: 0 auto;
        margin-top: 2rem;
        line-height: 32px;
        display: flex;
    }
    .input-box p{
        width: 20%;
        text-align: right;
    }
    .input-box .input{
        width: 80%;
    }
    .active-btn{
        text-align: center;
        margin-top: 2rem;
    }
    .active-btn .ant-btn{
        margin: 0 1rem;
    }

</style>
